module.exports = __webpack_public_path__ + "static/img/manual_ja_32.7bdf8d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_32.png
// module id = 0byF
// module chunks = 4